/**
 * Domain Configuration
 * This file is auto-generated based on the DOMAIN_NAME environment variable
 * Used to replace {{DOMAIN_NAME}} placeholders in locale files
 * 
 * Generated at: 2026-03-30T14:19:07.704Z
 */

// Domain name from environment variable (set at build time)
export const DOMAIN_NAME = 'meet-latina-usa.de'

export default DOMAIN_NAME
